import React from 'react';
import { Header } from '../../../components/ToxicDetector/Header';
import { HeroSection } from '../../../components/ToxicDetector/HeroSection';
import { TrustSection } from '../../../components/ToxicDetector/TrustSection';
import { FeaturesSection } from '../../../components/ToxicDetector/FeaturesSection';
import { GuaranteesSection } from '../../../components/ToxicDetector/GuaranteesSection';
import { ToolsSection } from '../../../components/ToxicDetector/ToolsSection';
import { ComparisonSection } from '../../../components/ToxicDetector/ComparisonSection';
import { PricingSection } from '../../../components/ToxicDetector/PricingSection';
import { FAQSection } from '../../../components/ToxicDetector/FAQSection';
import { CTASection } from '../../../components/ToxicDetector/CTASection';
import { Footer } from '../../../components/ToxicDetector/Footer';
import { MetaTags } from '../../../components/SEO/MetaTags';
import { PromoBanner } from '../../../components/Notifications/PromoBanner';
import { GoogleTranslateWidget } from '../../../components/GoogleTranslateWidget';
export function LandingPagePT() {
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/'
  }];
  return <>
      <MetaTags title="ToxicDetector: Análise de Relacionamentos com IA | Detecte Padrões Tóxicos e Gaslighting" description="Descubra se seu ex é o problema. Carregue seus chats para a IA do ToxicDetector para análise instantânea e confidencial de manipulação, gaslighting e sinais de alerta. Comece a análise gratuita hoje." keywords="análise de relacionamento com IA, detectar padrões tóxicos, detector de gaslighting, ex tóxico, verificador de manipulação, toxicidade em relacionamento, scanner de texto com IA" canonical="https://toxicdetector.com/pt" language="pt-BR" alternateUrls={alternateUrls} data-id="element-9190" />
      <GoogleTranslateWidget data-id="element-9191" />
      <PromoBanner data-id="element-9192" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-9193">
        <Header data-id="element-9194" />
        <main data-id="element-9195">
          <HeroSection h1Override={<>
                Seu Cérebro Está{' '}
                <span className="relative inline-block" data-id="element-9197">
                  <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-b from-gray-200 to-gray-500" data-id="element-9198">
                    Mentindo
                  </span>
                  <span className="absolute top-1/2 left-0 w-full h-[4px] md:h-[6px] bg-[#FF0000] -translate-y-1/2 rotate-[-2deg]" data-id="element-9199" />
                </span>{' '}
                Para Você.
                <br data-id="element-9200" />
                <span className="text-[#FF0000] drop-shadow-[0_0_30px_rgba(255,0,0,0.4)]" data-id="element-9201">
                  Nossa IA Não.
                </span>
              </>} data-id="element-9196" />
          <TrustSection data-id="element-9202" />
          <FeaturesSection data-id="element-9203" />
          <GuaranteesSection data-id="element-9204" />
          <ToolsSection data-id="element-9205" />
          <ComparisonSection data-id="element-9206" />
          <PricingSection data-id="element-9207" />
          <FAQSection data-id="element-9208" />
          <CTASection data-id="element-9209" />
        </main>
        <Footer data-id="element-9210" />
      </div>
    </>;
}